import { watch } from "vue";
import { useI18n } from "vue-i18n";
import { usePrimeVue } from "primevue/config";
export function useLocale() {
  const { locale } = useI18n();
  const prime = usePrimeVue();
  const defaults = { ...prime.config.locale };
  watch(
    locale,
    (value) => {
      localStorage.setItem("hello.locale", value);
      document.documentElement.lang = value;
      Object.assign(
        prime.config.locale!,
        value === "ro"
          ? {
              ...defaults,
              firstDayOfWeek: 1,
              accept: "Da",
              reject: "Nu",
              choose: "Alege",
              upload: "Încarcă",
              cancel: "Renunță",
              searchMessage: "{0} rezultate disponibile",
              selectionMessage: "{0} elemente selectate",
              emptySelectionMessage: "Niciun element selectat",
              chooseDate: "Alege data",
              chooseMonth: "Alege luna",
              chooseYear: "Alege anul",
              nextMonth: "Luna următoare",
              prevMonth: "Luna anterioară",
              aria: {
                ...defaults.aria,
                firstPageLabel: "Prima pagină",
                previousPageLabel: "Pagina anterioară",
                nextPageLabel: "Pagina următoare",
                lastPageLabel: "Ultima pagină",
                pageLabel: "Pagina {page}",
                rowsPerPageLabel: "Rezultate pe pagină",
                selectAll: "Selectează tot",
                unselectAll: "Deselectează tot",
                close: "Închide",
                showPassword: "Arată parola",
                hidePassword: "Ascunde parola",
              },
              dayNames: [
                "Duminică",
                "Luni",
                "Marți",
                "Miercuri",
                "Joi",
                "Vineri",
                "Sâmbătă",
              ],
              dayNamesShort: ["Du", "Lu", "Ma", "Mi", "Jo", "Vi", "Sâ"],
              dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
              monthNames: [
                "Ianuarie",
                "Februarie",
                "Martie",
                "Aprilie",
                "Mai",
                "Iunie",
                "Iulie",
                "August",
                "Septembrie",
                "Octombrie",
                "Noiembrie",
                "Decembrie",
              ],
              monthNamesShort: [
                "Ian",
                "Feb",
                "Mar",
                "Apr",
                "Mai",
                "Iun",
                "Iul",
                "Aug",
                "Sep",
                "Oct",
                "Noi",
                "Dec",
              ],
              today: "Astăzi",
              clear: "Șterge",
              emptyMessage: "Niciun rezultat",
              emptySearchMessage: "Niciun rezultat",
            }
          : defaults,
      );
    },
    { immediate: true },
  );
}
